import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/loader.gif'
import _imports_1 from '@/assets/imgs/chip_selector.png'
import _imports_2 from '@/assets/imgs/chipsc.webp'
import _imports_3 from '@/assets/imgs/chipsc.png'
import _imports_4 from '@/assets/imgs/chips_seting_btn.webp'
import _imports_5 from '@/assets/imgs/chips_seting_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0f862b80")

_pushScopeId("data-v-0f862b80")
const _hoisted_1 = _imports_2
const _hoisted_2 = _imports_4
const _hoisted_3 = { class: "multi-view-root" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  class: "left-content",
  id: "box1"
}
const _hoisted_7 = { class: "center-content" }
const _hoisted_8 = { class: "video-other-wrap" }
const _hoisted_9 = /*#__PURE__*/_createVNode("canvas", {
  id: "videoplayer2",
  class: "player"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("canvas", {
  id: "videoplayer1",
  class: "player"
}, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "loading"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("picture", null, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_13 = { class: "timer-table-no-status" }
const _hoisted_14 = { class: "table-no-status" }
const _hoisted_15 = { class: "table-no" }
const _hoisted_16 = { class: "status" }
const _hoisted_17 = { class: "chips" }
const _hoisted_18 = {
  key: 0,
  src: _imports_1,
  class: "active",
  alt: ""
}
const _hoisted_19 = { class: "chip-container" }
const _hoisted_20 = {
  key: 0,
  src: _imports_1,
  class: "active",
  alt: ""
}
const _hoisted_21 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_1
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/chipsc.png"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_2
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/chips_seting_btn.png",
  draggable: "false"
}, null, -1)
const _hoisted_25 = { class: "center-list" }
const _hoisted_26 = { class: "center-list-content" }
const _hoisted_27 = {
  class: "right-content",
  id: "box2"
}
const _hoisted_28 = { class: "footer" }
const _hoisted_29 = {
  key: 0,
  class: "notice-wrap"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "notice-label" }, "最新消息:", -1)
const _hoisted_31 = {
  key: 1,
  class: "contact-wrap"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "服务热线 +85585801111", -1)
const _hoisted_33 = { class: "time" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "icon-msg" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "icon-call" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "icon-warning" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "icon-agent" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "icon-max" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "icon-home" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_view = _resolveComponent("header-view")
  const _component_multi_view_side_list_item = _resolveComponent("multi-view-side-list-item")
  const _component_multi_view_center_list_item = _resolveComponent("multi-view-center-list-item")
  const _component_marquee_text = _resolveComponent("marquee-text")
  const _component_pc_switch_table = _resolveComponent("pc-switch-table")
  const _component_d_good_road_panel = _resolveComponent("d-good-road-panel")
  const _component_custom_money_view = _resolveComponent("custom-money-view")
  const _component_limit_dialog_view = _resolveComponent("limit-dialog-view")
  const _component_setting_view = _resolveComponent("setting-view")
  const _component_change_password_view = _resolveComponent("change-password-view")
  const _component_bet_history = _resolveComponent("bet-history")
  const _component_rule_view = _resolveComponent("rule-view")

  return (_openBlock(), _createBlock("div", _hoisted_3, [
    _createVNode(_component_header_view, {
      class: "header",
      isOnLoby: false,
      isMultiView: true,
      goodRoadCount: _ctx.goodRoadCount,
      onShowSwitchTable: _ctx.OnShowSwitchTable,
      onOnShowSingleShow: _ctx.OnShowGoodRoad,
      onOnShowLimit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLimitDialog = true)),
      onOnShowSetting: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSettings = true))
    }, null, 8, ["goodRoadCount", "onShowSwitchTable", "onOnShowSingleShow"]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.leftListData, (i) => {
          return (_openBlock(), _createBlock(_component_multi_view_side_list_item, {
            class: "static-item",
            key: `left-s-${i.id}`,
            deskData: i,
            chipAmount: _ctx.chip,
            isDragActive: _ctx.activeDragIndex === i.id,
            isSuper6Mode: _ctx.isSuper6Mode,
            onSwitchFocusDesk: _ctx.OnSwitchDeskFocus,
            onDragenter: _withModifiers(($event: any) => (_ctx.activeDragIndex = i.id), ["prevent"]),
            onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
            onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleDragLeave($event)), ["prevent"])),
            onDrop: _withModifiers(($event: any) => (_ctx.handleDrop(i, $event)), ["prevent"])
          }, null, 8, ["deskData", "chipAmount", "isDragActive", "isSuper6Mode", "onSwitchFocusDesk", "onDragenter", "onDrop"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          (_ctx.videoIsLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_13, [
            _createVNode("span", {
              class: ["timer", [
                                _ctx.timerColor,
                                _ctx.currentCount < 11 && _ctx.currentCount > -1
                                    ? 'pulsing'
                                    : ''
                            ]]
            }, _toDisplayString(_ctx.currentCount > -1 ? _ctx.currentCount : ''), 3),
            _createVNode("div", _hoisted_14, [
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.title), 1),
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.currentCount > -1 ? '开始接受投注' : '停止投注'), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chips, (chpAmt, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "chip-container",
              key: i
            }, [
              (_ctx.chipIndex === i)
                ? (_openBlock(), _createBlock("img", _hoisted_18))
                : _createCommentVNode("", true),
              _createVNode("picture", {
                class: "chip",
                onClick: ($event: any) => (_ctx.chipClicked(i, chpAmt))
              }, [
                _createVNode("source", {
                  type: "image/webp",
                  srcset: _ctx.getChipImageWebp(chpAmt)
                }, null, 8, ["srcset"]),
                _createVNode("img", {
                  src: _ctx.getChipImageWebpPng(chpAmt),
                  "data-was-processed": "true",
                  "data-src": _ctx.getChipImageWebpPng(chpAmt),
                  draggable: "false"
                }, null, 8, ["src", "data-src"])
              ], 8, ["onClick"])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_19, [
            (_ctx.chipIndex === 5)
              ? (_openBlock(), _createBlock("img", _hoisted_20))
              : _createCommentVNode("", true),
            _createVNode("picture", {
              class: "chip",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showChipDialog(false))),
              draggable: "false"
            }, [
              _hoisted_21,
              _hoisted_22,
              _createVNode("span", null, _toDisplayString(_ctx.getCustomChipValue()), 1)
            ])
          ]),
          _createVNode("picture", {
            class: "chip-setting",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showChipDialog(true)))
          }, [
            _hoisted_23,
            _hoisted_24
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.centerListData, (i) => {
              return (_openBlock(), _createBlock(_component_multi_view_center_list_item, {
                draggable: "true",
                class: "center-list-item",
                key: `center-s-${i.id}`,
                deskData: i,
                onDragstart: ($event: any) => (_ctx.handleDragStart(i, $event))
              }, null, 8, ["deskData", "onDragstart"]))
            }), 128))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_27, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rightListData, (i) => {
          return (_openBlock(), _createBlock(_component_multi_view_side_list_item, {
            class: "static-item",
            chipAmount: _ctx.chip,
            key: `right-s-${i.id}`,
            deskData: i,
            isDragActive: _ctx.activeDragIndex === i.id,
            isSuper6Mode: _ctx.isSuper6Mode,
            onSwitchFocusDesk: _ctx.OnSwitchDeskFocus,
            onDragenter: _withModifiers(($event: any) => (_ctx.activeDragIndex = i.id), ["prevent"]),
            onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
            onDragleave: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.handleDragLeave($event)), ["prevent"])),
            onDrop: _withModifiers(($event: any) => (_ctx.handleDrop(i, $event)), ["prevent"])
          }, null, 8, ["chipAmount", "deskData", "isDragActive", "isSuper6Mode", "onSwitchFocusDesk", "onDragenter", "onDrop"]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_28, [
      (_ctx.isNoticeView)
        ? (_openBlock(), _createBlock("div", _hoisted_29, [
            _hoisted_30,
            _createVNode("div", {
              class: "notice",
              onMouseover: _cache[9] || (_cache[9] = ($event: any) => (_ctx.noticeIsPaused = true)),
              onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.noticeIsPaused = false))
            }, [
              _createVNode(_component_marquee_text, {
                class: "m-notice",
                key: _ctx.deskInfoKey,
                animate: !_ctx.noticeIsPaused,
                speed: 30
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.lobyNotice), 1)
                ]),
                _: 1
              }, 8, ["animate"])
            ], 32)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_31, [
            _hoisted_32
          ])),
      _createVNode("div", _hoisted_33, _toDisplayString(_ctx.dateTimeStr), 1),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isNoticeView = true))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
        }, "最新消息"),
        _hoisted_34
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isNoticeView = false))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
        }, "服务热线 "),
        _hoisted_35
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.OnClickRules && _ctx.OnClickRules(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
        }, "游戏规则"),
        _hoisted_36
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.OnClickCustumerService && _ctx.OnClickCustumerService(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
        }, "线上客服"),
        _hoisted_37
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.OnCLickToggleFullScreen && _ctx.OnCLickToggleFullScreen(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
        }, "全屏幕"),
        _hoisted_38
      ]),
      _createVNode("div", {
        class: "icon",
        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.toLoby && _ctx.toLoby(...args)))
      }, [
        _createVNode("span", {
          class: "tool-tip",
          onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
        }, "返回大厅"),
        _hoisted_39
      ])
    ]),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withId(() => [
        (_ctx.showSwicthTable)
          ? (_openBlock(), _createBlock(_component_pc_switch_table, {
              key: 0,
              class: "switch-desk",
              showSelected: false,
              onOnHideSwitchTable: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showSwicthTable = false)),
              onOnSwitchTable: _ctx.onSwitchTable
            }, null, 8, ["onOnSwitchTable"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withId(() => [
        (_ctx.showGoodRoadPanel)
          ? (_openBlock(), _createBlock(_component_d_good_road_panel, {
              key: 0,
              class: "good-road-panel",
              onOnHideGoodRoad: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showGoodRoadPanel = false)),
              onOnGoodRoadSync: _ctx.onGoodRoadSync
            }, null, 8, ["onOnGoodRoadSync"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showCustumChip)
          ? (_openBlock(), _createBlock(_component_custom_money_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showCustumChip = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showLimitDialog)
          ? (_openBlock(), _createBlock(_component_limit_dialog_view, {
              key: 0,
              class: "full-dialog",
              gType: _ctx.gType,
              onOnClose: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showLimitDialog = false))
            }, null, 8, ["gType"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showSettings)
          ? (_openBlock(), _createBlock(_component_setting_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showSettings = false)),
              onOnShowChangePasswordForm: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showPasswordForm = true)),
              onOnShowHistory: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showHistory = true)),
              onOnShowRule: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showRule = true))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showPasswordForm)
          ? (_openBlock(), _createBlock(_component_change_password_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showPasswordForm = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showHistory)
          ? (_openBlock(), _createBlock(_component_bet_history, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showHistory = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showRule)
          ? (_openBlock(), _createBlock(_component_rule_view, {
              key: 0,
              class: "full-dialog",
              onClose: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showRule = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})